export const anchorDownload = {
  mounted() {
    const url = this.el.getAttribute("href")
    this.el.addEventListener("click", async (e) => {
      e.preventDefault()
      const response = await fetch(url)
      const data = await response.blob()
      const filename = this.el.dataset.filename
      const blobUrl = URL.createObjectURL(data)
      const a = document.createElement("a")
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    })
  },
}
